import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const SuccessSendPopup = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.success}>
      <h2 dangerouslySetInnerHTML={{__html: t("popup.success_send.title")}} />

      <p dangerouslySetInnerHTML={{__html: t("popup.success_send.desc")}} />
    </div>
  );
};
